import { Component, input } from '@angular/core';

@Component({
  selector: 'app-view-icon',
  standalone: true,
  imports: [],
  templateUrl: './view-icon.html',
  host: { class: 'flex h-6 w-6 shrink-0 items-center justify-center', 'aria-hidden': 'true' },
})
export class ViewIcon {
  readonly route = input<string | null>(null);
}
